<template>
  <main class="main product-list-page product-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section"></section>

      <section class="section product-list-section">
        <div class="wrapper">
          <transition name="fade">
            <div class="product-preview" v-if="productPageItem">
              <div class="preview-container">
                <div class="preview-wrapper">
                  <div class="preview">
                    <img
                        v-if="productPageItem.pack_id && type !== 'prompt'"
                        :src="imgDomain + '/' + activePack.image_url"
                        class="img"
                    />
                    <img
                        v-else
                        :src="imgDomain + '/' + productPageItem.image_url"
                        class="img"
                    />
                  </div>
                </div>
              </div>

              <div class="text">
                <div class="text-wrapper">
                  <div class="title title-main">
                    {{ productPageItem.pack_id && type !== 'prompt' ? activePack.title : productPageItem.title }}
                  </div>

                  <div class="tag">
                    <div class="desc"><b>{{ $t('Model:') }}</b></div>
                    <div class="desc">{{ tag }}</div>
                  </div>

                  <div class="desc description">
                    <b>{{ $t('Description:') }}</b>
                  </div>

                  <div class="desc" v-html="productPageItem.pack_id && type !== 'prompt' ? activePack.description : productPageItem.description"></div>

                  <div class="row-price">
                    <div class="desc"><b>{{ $t('Price:') }}</b></div>
                    <div class="title">
                      {{ productPageItem.pack_id && type !== 'prompt' ? activePack.price : productPageItem.price }}
                      <span class="currency">{{ currency }}</span>
                    </div>
                    <button class="button" @click="getPromt">
                      <span>{{ type === 'pack' ? $t('Get pack') : $t('Get prompt') }}</span>
                      <img src="./../img/cartSmall.svg" class="img" />
                    </button>
                  </div>

                  <div class="spec-text">
                    <div class="desc">
                      {{ $t('After purchasing, you will gain access to the prompt file.') }}
                      <br />
                      <div>
                        {{ type === 'pack' ? $t('By purchasing this bundle, you agree to our ') : $t('By purchasing this prompt, you agree to our ') }}
                        <a href="javascript:void(0);" @click="goToPage('terms')">{{ $t('terms of service') }}</a>.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div
                class="list products"
                v-if="(productPageItem.pack_id && type !== 'prompt' && productList) || type === 'pack'"
            >
              <div class="item" v-for="(item, i) in productList" :key="i">
                <ProductCard
                    :models="modelOptions"
                    :tag="item.parent_cat_id"
                    :item="item"
                    :sliderIsClickble="true"
                    @goToProduct="goToProduct"
                    @openReadyModal="(itemType, product) => $emit('openReadyModal', itemType, product)"
                    @openSignInModal="() => $emit('openSignInModal')"
                    :currency="currency"
                />
              </div>
            </div>
          </transition>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { defineComponent } from 'vue';
import ProductCard from '../components/ProductCard.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'ProductPage',

  inject: [
    'productPageItem',
    'imgDomain',
    'goToPage',
    'setReadyPrompt',
    'openReadyModal'
  ],

  emits: [
    'openReadyModal',
    'openSignInModal',
    'getProductPageContent',
    'goToProduct',
  ],

  props: ['currency', 'type'],

  components: {
    ProductCard
  },

  data() {
    return {
      tag: '',
      activePack: '',
      productList: [],
      modelOptions: [],
    }
  },

  watch: {
    currency() {
      const id = this.$route.params.id;
      this.$emit('getProductPageContent', id);
    },
    productPageItem(newVal) {
      this.getActivePack();
      this.$http.get( 'categories')
          .then((res) => {
            this.models = res.data.payload.filter(item => item.parent_id === null);
            const newTagObj = this.models.find(item => item.id === newVal.parent_cat_id);
            if (newTagObj) this.tag = newTagObj.title;
          })
          .catch(() => { });
    }
  },

  mounted() {
    this.getActivePack();
    this.getModels();
  },

  methods: {
    getModels() {
      this.$http.get( 'categories')
          .then((res) => {
            const newCategories = res.data.payload.filter(item => item.parent_id === null);
            this.modelOptions = newCategories.map(({ id, title: text, url }) => ({ id, text, url }));
            this.modelOptions.unshift({ id: 0, text: 'All', url: '' });
          })
          .catch(() => { });
    },

    getActivePack() {
      if (this.productPageItem?.product_type === 'pack') {
        if (!this.productPageItem) {
          this.$emit('getProductPageContent', this.$route.params.id, this.type);
        }
        this.$http.get( 'packs/' + this.productPageItem.id + '/info')
            .then((res) => {
              this.activePack = res.data.payload;
              this.$http.get( 'packs/' + this.activePack.id)
                  .then((res) => {
                    this.productList = res.data.payload;
                  })
                  .catch(() => { });
            })
            .catch(() => { });
      } else {
        if (!this.productPageItem) {
          this.$emit('getProductPageContent', this.$route.params.id, this.type);
        }
      }
    },

    openReadyModal() {
      this.setReadyPrompt();
      this.openReadyModal();
    },

    getPromt() {
      if (this.isAuth) {
        const product = this.productPageItem;
        const itemType = product?.product_type || (this.type === 'pack' ? 'pack' : 'prompt');
        this.$emit('openReadyModal', itemType, product);
      } else {
        this.$emit('openSignInModal');
      }
    },

    goToProduct(item) {
      this.$emit('goToProduct', item);
    }
  },

  computed: {
    ...mapGetters('user', ['isAuth'])
  }
});
</script>
